<template>
    <modal :title="operator.Name+' Detail'" :size="'xl'" @close="$emit('close')">
        <template #content>
            <ul class="nav nav-tabs profile-tab border-bottom">
                <li class="nav-item"><a href="javascript:;" @click="tab='Update'" :class="{'active':tab=='Update'}" class="nav-link">Update</a></li>
                <li class="nav-item"><a href="javascript:;" @click="tab='Cookies'" :class="{'active':tab=='Cookies'}" class="nav-link">Cookies</a></li>
            </ul>
            <update v-if="tab=='Update'" :operators="operators" :id="operator.Id" @update="$emit('update',$event)"></update>
            <cookies v-if="tab=='Cookies'" :id="operator.Id" @get="$emit('get')"></cookies>
            <!-- <upsert :setModel="setModel" @update="$emit('update',$event)" v-if="tab=='Detail'"></upsert>
            <hotels :setModel="setModel" v-if="tab=='Hotels'"></hotels>
            <users :setModel="setModel" v-if="tab=='Users'"></users>
            <providers :setModel="setModel" v-if="tab=='Providers'"></providers> -->
        </template>
    </modal>
</template>

<script>
    import update from "./update";
    import cookies from "./cookies/main";
    // import hotels from "./hotels/main";
    // import users from "./users/main";
    // import providers from "./providers/main";
    export default {
        name:"detail",
        components:{update,cookies},
        props:{
            operators:Array,
            operator:Object
        },
        data(){
            return{
                tab:"Update"
            }
        }
    }
</script>

<style>

</style>